import type { AllianceFeeRequest } from '../types/ProvidedJobPost';
import useUpdateProvidedJobPostSettings from './useUpdateProvidedJobPostSettings';

/**
 * アライアンス成約条件を更新する mutation hook。
 * useUpdateProvidedJobPostSettings を薄くラップし、alliance_fee 専用のインタフェースを提供する。
 * null を渡すと既存レコードが削除される（バックエンドの仕様に準拠）。
 */
export default function useUpdateAllianceFee(jobPostId: number) {
  const updateSettings = useUpdateProvidedJobPostSettings(jobPostId);

  const mutate = (allianceFee: AllianceFeeRequest) => {
    updateSettings.mutate({ alliance_fee: allianceFee });
  };

  const mutateAsync = async (allianceFee: AllianceFeeRequest) => {
    return updateSettings.mutateAsync({ alliance_fee: allianceFee });
  };

  return {
    mutate,
    mutateAsync,
    isPending: updateSettings.isPending,
    isError: updateSettings.isError,
    error: updateSettings.error,
    data: updateSettings.data,
  };
}
